import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Button from "../../../../../common/buttons/Button";

import {
  showErrorToast,
  showSuccessToast,
} from "../../../../../../utils/toaster";

import * as Yup from "yup";
import {
  createTemplate,
  getAllMedicines,
} from "../../../../../../api/settings/Medicines/medicines";
import { formatToSearchDate } from "../../../../../../utils/date";
import InputBox from "../../../../../common/input/InputBox";
import Medicines from "../../../../Prescriptions/pages/CreatePrescription/medicines/Medicines";
import Notes from "../../../../Prescriptions/pages/CreatePrescription/notes/Notes";
const medicineInfo = {
  medicine: "",
  days: "",
  before_after_food: "",
  morning: "",
  afternoon: "",
  evening: "",
  night: "",
  medicine_type: "",
  quantity: 0,
};

const initialValues = {
  medicine_info: [medicineInfo],
  notes: "",
  date: new Date(),
};

const validationSchema = Yup.object().shape({
  medicine_info: Yup.array().of(
    Yup.object().shape({
      medicine: Yup.string().required("required"),
      days: Yup.number().notRequired(),
      before_after_food: Yup.string().notRequired(),
      morning: Yup.number().notRequired(),
      afternoon: Yup.number().notRequired(),
      evening: Yup.number().notRequired(),
      night: Yup.number().notRequired(),
      medicine_type: Yup.string().notRequired(" "),
    })
  ),
  notes: Yup.string().notRequired(),
  date: Yup.string().required(),
});

const CreateTemplate = ({ handleClose, getAllTemplatesData }) => {
  const [loading, setLoading] = useState(false);
  const [medicines, setMedicines] = useState([]);
  const [searchMedicines, setSearchMedicines] = useState("");

  /** Adding New row */
  const addRow = () => {
    formik.setValues({
      ...formik.values,
      medicine_info: [...formik.values.medicine_info, medicineInfo],
    });
    // setSearchKey("");
    setSearchMedicines("");
  };

  /** Removing row using index */
  const removeRow = (index) => {
    const updatedItems = [...formik.values.medicine_info];
    updatedItems.splice(index, 1);
    if (updatedItems?.length >= 1) {
      formik.setValues({
        ...formik.values,
        medicine_info: updatedItems,
      });
    }
  };

  const validateSelections = (
    items,
    validItems,
    itemKeyFn,
    validKeyFn,
    errorMessage
  ) => {
    const hasInvalid = items.some((item) => {
      const itemKey = itemKeyFn(item);
      // Skip validation for items with an empty key
      if (!itemKey) return false;

      return !validItems.some((valid) => validKeyFn(valid) === itemKey);
    });

    if (hasInvalid) {
      showErrorToast(errorMessage);
      setLoading(false);
    }

    return hasInvalid;
  };

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const payload = {
        ...values,
        date: formatToSearchDate(values.date),
      };

      const validations = [
        {
          items: values?.medicine_info || [],
          validItems: medicines,
          itemKeyFn: (item) => item.medicine,
          validKeyFn: (valid) => valid.medicine,
          errorMessage:
            "Invalid Medicine Selected. Please select valid medicine.",
        },
      ];

      for (const validation of validations) {
        const { items, validItems, itemKeyFn, validKeyFn, errorMessage } =
          validation;
        if (
          validateSelections(
            items,
            validItems,
            itemKeyFn,
            validKeyFn,
            errorMessage
          )
        ) {
          return; // Exit early on the first invalid selection
        }
      }

      setLoading(true);
      createTemplate(payload)
        .then((response) => {
          showSuccessToast("Template Added");
          handleClose();
          getAllTemplatesData();
        })
        .catch((error) => {
          showErrorToast(error);
        })
        .finally(() => {});
    },
  });

  const getAllMedicinesData = () => {
    getAllMedicines(searchMedicines)
      .then((response) => {
        setMedicines(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getAllMedicinesData();
  }, [searchMedicines]);

  return (
    <div className="grid gap-5 pb-10">
      <div>
        <InputBox
          placeholder="Enter Template Name"
          className={"!h-[54px]"}
          value={formik.values.template_name}
          title="Template Name"
          onChange={(e) =>
            formik.setFieldValue("template_name", e.target.value)
          }
        />
      </div>
      <form className="grid gap-2" onSubmit={formik.handleSubmit}>
        <Medicines
          formik={formik}
          addRow={addRow}
          removeRow={removeRow}
          medicines={medicines}
          setSearchMedicines={setSearchMedicines}
          searchMedicines={searchMedicines}
        />
        <Notes formik={formik} />
        <div className="grid lg:grid-cols-3">
          <div className="lg:col-start-4 lg:w-[250px]">
            <Button type={"primary"} className={"text-heading2B"}>
              Create Template
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreateTemplate;
